import { createFeatureSelector, createSelector } from '@ngrx/store';

import { NavigationState } from './navigation.state';

export const selectNavigationState = createFeatureSelector<NavigationState>('navigation');

export const selectCurrentProductUuid = createSelector(
  selectNavigationState,
  (state) => state.currentProductUuid
);

export const selectCurrentCategory = createSelector(
  selectNavigationState,
  (state) => state.currentCategory
);

export const selectNavigationLoading = createSelector(
  selectNavigationState,
  (state) => state.isLoading
);

export const selectHasCurrentProduct = createSelector(
  selectCurrentProductUuid,
  (productUuid) => !!productUuid
);
